import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/brain/library/')({}).lazy(() =>
  import('./library.index.lazy').then((d) => d.Route),
);
